<template>
  <sPopover
    v-model="visible"
    :open-delay="300"
    placement="bottom-end"
    popper-class="tooltip h8-text text-start"
    transition="s-zoom-in-top"
    trigger="manual">
    <div
      slot="reference"
      class="ml-auto">
      <sButton
        data-qa="btn-additional-field-menu"
        icon="menu"
        small
        type="text"
        @click.stop="visible = !visible"/>
    </div>
    <div
      class="org-settings__menu"
      :data-qa="dataQa">
      <div
        v-for="(menu_item, index) in menu_list"
        :key="index"
        class="list__item list-item d-flex align-center py-2 px-3"
        @click="menu_item.click(item)">
        <sIcon
          class="list-item__icon my-auto mr-2"
          :type="menu_item.icon"/>
        <div class="list-item__text text-start h11-links">
          {{ menu_item.text }}
        </div>
      </div>
    </div>
  </sPopover>
</template>
<script>
import organizerSettings from 'mixins/organizerSettings'

export default {
  name: 'organizerSettingMenu',
  mixins: [organizerSettings],
  data() {
    return {
      visible: false,
      menu_list: [
        {
          text: this.$t('Common.Edit'),
          icon: 'edit',
          click: this.showModalEdit
        },
        {
          text: this.$t('Common.Copy'),
          icon: 'docs',
          click: this.showModalCopy
        },
        {
          text: this.$t('Purchasing.Remove'),
          icon: 'delete',
          click: this.deleteQuestion
        },
      ],
    }
  },
  methods: {
    showModalEdit(item) {
      this.visible = false
      this.$emit('edit', item)
      this.$log('edit', item)
    },
    async delete() {
      await this.$_deleteSetting(this.item)
        .then((result) => {
          if (result?.success) {
            this.$log('delete', this.item)
            this.$emit('delete', this.item)
          } else {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Errors.STHWrong'),
              duration: 10,
            })
          }
        })
        .catch(error => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: error?.message || error?.lotMessages.map(er => er.message).join(', '),
            duration: 10,
          })
        })
        .finally(() => {
          this.$Modal.remove()
        })
    },
    deleteQuestion(item) {
      this.visible = false
      this.$Modal.confirm({
        title: `${this.$t('OrgSettings.DeleteQuestin')}?`,
        content:
          `Налаштування:</br><u>${item.settingInfo.settingTitle}</u></br></br>${this.$t('Tenders.Organizer')}</br><u>${item.organizationView.organizationTitle}</u>`,
        closable: true,
        okText: this.$t('Purchasing.Remove'),
        cancelText: this.$t('Common.Close'),
        dangerouslyUseHTMLString: true,
        loading: true,
        onOk: this.delete,
      })
    },
    showModalCopy(item) {
      this.visible = false
      this.$emit('showModalCopy', item)
    },
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    dataQa: {
      type: String,
      default: 'organizer-setting-menu'
    }
  },
}
</script>
<style scoped lang="scss">
.org-settings__menu {
  overflow: hidden;
  background: var(--v-main__light_green-base);
  border: 1px solid var(--color-main-green);
  .list-item {
    cursor: pointer;
    min-height: 40px;
    display: flex;
    width: 100%;
    &:hover,
    &:focus {
      background-color: #ddeceb;
    }
  }
}
</style>
